import React, { useContext } from "react";
import { GlobalDataContext } from "../../context/context";
import { ButtonContent } from "../global/boton/ButtonContent";

function HeroSection({bgImg1, bgImg2, bgImg3, bgImg4}) {
  const { rpdata } = useContext(GlobalDataContext);

  const bgImg = [
    bgImg1,
    bgImg2,
    bgImg3,
    bgImg4
  ]
  return (
    <>
      <div className="pic-wrapper">
        {
          bgImg.map((item, index) => (
            <figure
              key={index}
              className={`pic-${index + 1}`}
              style={{ background: `url("${item}")` }}
            ></figure>
          ))
        }
        <div className="z-[4] relative w-4/5 mx-auto md:h-[140vh] h-[160vh]">
          <div className="w-full h-full pb-[15%] md:pb-[10%] flex flex-col justify-end items-center">
            <h1 className="text-white text-center">
              {rpdata?.dbSlogan?.[0].slogan}
            </h1>
            <p className="text-white text-center">{rpdata?.dbValues?.[1].description}</p>
            <div className="flex justify-center md:block">
              <ButtonContent />
            </div>
          </div>
          <div className="w-1/2"></div>
        </div>
      </div>
    </>
  );
}

export default HeroSection;
